import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import MessageNotificationComponent from "./Categories/MessageNotification.vue";
import SharedItemNotificationComponent from "./Categories/SharedItemNotification.vue";
/**
 * A map of notification categories to their corresponding Vue components.
 */
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationItem',
    props: {
        notification: null
    },
    setup(__props) {
        const props = __props;
        const notificationComponentMap = {
            message: MessageNotificationComponent,
            new_shared_item: SharedItemNotificationComponent,
        };
        const notificationComponent = computed(() => notificationComponentMap[props.notification.category]);
        return { __sfc: true, notificationComponentMap, props, notificationComponent };
    }
});
